module.exports = __webpack_public_path__ + "media/images/round_robin-f66d40137f009d93921e5eb237138bfa.png";